import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2'

import * as apiCompany from "../../../../api/apiCompany"
import * as Auth from "../../../Login/Auth"
import { Pagination } from '../../Res/Pagination';
import { AdminRoleAdd } from './RoleAdd';
import { AdminRoleEdit } from './RoleEdit';
import { ContentBox } from '../../Content/ContentBox';
import { EditButton } from '../../Res/BaseButton';

export function AdminRoleList ({id}) {
  const [disableCount, setDisableCount] = useState(0)
  const [enableCount, setEnableCount] = useState(0)
  const [isEdit, setisEdit] = useState(false)
  const [role, setRole] = useState()
  const [change, setChange] = useState(false)
  const [department, setDepartment] = useState()
  const [departmentList, setDepartmentList] = useState()
  const [company, setCompany] = useState()

  var title = (department !== undefined?department.companyName +" - "+ department.departmentName:"")+"角色列表"
  var title_tools = ''
  var content = 
  <ListBox id={id} setDisableCount={setDisableCount} setEnableCount={setEnableCount} toEdit={toEdit} ch={change} setList={setDepartmentList} setCompany={setCompany} setDepartment={setDepartment} />  

  function toEdit(status, c){
    console.log("toEdit")
    setisEdit(status)
    setDepartment(c)
    if(!status){
      setChange(!change)
    }
  }

  function toEdit(status, item){
    console.log("toEdit")
    setisEdit(status)
    setRole(item)
    if(!status){
      setChange(!change)
    }
  }

  function cancel(){
    setChange(!change)
  }

  function getRoleList(){
    setChange(!change)
  }

  return (    
    <>
    <ContentBox title={title} enableCount={enableCount} disableCount={disableCount} disableText={"停權"} title_tools={title_tools} content={content}  hasDrawer={true} />
    {
        departmentList === undefined?<></>:
        isEdit?<AdminRoleEdit cancel={toEdit} role={role} /> :
          <AdminRoleAdd departmentId={id} roleList={[]} getRoleList={getRoleList} />
    }
    </>
  )
}


function ListBox({id, setDisableCount, setEnableCount, toEdit, ch, setList, setCompany, setDepartment}){
  const [roleList, setRoleList] = useState()
  const [page, setPage] = useState(1)
  const [count, setCount] = useState(0)
  const [limit] = useState(10)
  const [change, setChange] = useState(ch)
  //const [count, setCount] = useState(0)

  function getRoleList(){
    apiCompany.api_getRoleList({
      departmentId: id, 
      success: (obj)=>{
        setCompany(obj.company)
        setDepartment(obj.department)
        setRoleList(obj.list)
        setCount(obj.count)
        setDisableCount(obj.disableCount)
        setEnableCount(obj.enableCount)
        setList(obj.list)
        console.log(obj)
      },
      failure: ()=>{
      }
    })
  }

  function sPage(p){
    if(p !== page){
      getRoleList()
      setPage(p)
    }
  }


  useEffect(()=>{
    if(roleList === undefined){
      getRoleList()
    }
  },[])

  useEffect(()=>{
    if(change !== ch){
      setChange(ch)
      getRoleList()
    }
  })


  if(roleList === undefined){
    return (<></>)
  }else{
    //console.log(managerList)
    return(
    <>
    <div className="box-body table-responsive no-padding">
    <table className="table no-margin">
      <tbody><tr>
        <th width="20%">角色名稱</th>
        <th width="20%">部門</th>
        <th width="20%">是否為主管</th>
        <th width="10%">狀態</th>
        <th width="20%">上級</th>
        <th width="10%"></th>
      </tr>
      {
        roleList.map((role)=>(
          <Box key={role.roleId} item={role} toEdit={toEdit} />
        ))
        }
      
      </tbody>
    </table>
    </div>
    {
      count === 0? <></> : <Pagination p={page} l={limit} c={count} sp={sPage} />
    }
    </>
  )
  }
  
}

function Box({item, toEdit}){
  const [role, setRole] = useState(item)
  if(role !== item){
    setRole(item)
  }

  function toRole(){
    toEdit(false);
    //window.location.assign("/AdminRoleList/"+role.departmentId);
  }

  var status ="<></>";
  if(role.isDisable === 1){
    status = <span className="label label-danger">停用</span>
  }else{
    status = <span className="label label-success">啟用</span>
  }
  
  var Supervisor = "";
  if(role.isSupervisor === 1){
    Supervisor = <span className="text-danger"><i className="fa fa-check"></i></span>
  }else{
    //Supervisor = <span className="glyphicon glyphicon-remove text-success"></span>
  }

  function edit(){
    toEdit(true, role)
  }

  return(
    <tr>
      <td style={{verticalAlign:"middle"}}><div>{role.roleName}</div></td>
      <td style={{verticalAlign:"middle"}}>{role.departmentName}</td>
      <td style={{verticalAlign:"middle"}}>{Supervisor}</td>
      <td style={{verticalAlign:"middle"}}>{status}</td>
      <td style={{verticalAlign:"middle"}}>{role.managerRoleName}</td>
      <td style={{verticalAlign:"middle"}}>
        <div className="btn-group">
          <EditButton action={edit} />
        </div>
      </td>
    </tr>
  )
}